import React, {useContext} from "react";
import classNames from "classnames";
import {set} from "lodash";
import {Collapse} from "antd";
import {BOOKING_ERROR_TO_PANEL} from "../consts";
import {OrderForm} from "../../OrderForm";
import {PaymentPanel} from "../Payment/PaymentPanel";
import {expandIconController, MarketplaceSeparatorLine} from "../../MarketplaceHelper";
import {OrderFormPanelKeys} from "../../consts";
import {AllowedSystemIdPaymentType} from "../../../consts.js";
import {isCompanySubAdmin} from "../../../center/EXCenterHelper";
import {MarketplaceContext} from "../../marketplaceContext";
import {OrderVoucherForm} from "../../OrderVoucherForm";
import "../marketplace-booking.css";
import {getThemeByOrigin} from "../../../utils.js";
import {NOOP} from "../../../utils/NOOP.jsx";
import {ProductBookingContext} from "./ProductBookingContext.jsx";

export const ProductBookingForm = ({readOnlyFields = [], adminMode = false}) => {
    const {product, providerDetails, userFormValues, highlightOrderPanel} = useContext(MarketplaceContext);

    const {
        me,
        company = {},
        formValues,
        setFormValues,
        bookingError,
        activeKey,
        setActiveKey,
        log = NOOP,
        officeAddress,
        onFormValueChange,
        onBudgetCategoriesPriorityChange,
        onSeparateInvoiceChange,
        onInvoicePONumberChange,
        onInvoiceCommentChange,
        calculateModularProductPrice,
        setCreditCard,
        totalLoadRequestBudgetAmount,
        setPaymentType,
        services,
        onSyncUserBudget
    } = useContext(ProductBookingContext);

    return (
        <div className="booking-form-content">
            {providerDetails?.isVoucherProvider ? (
                <OrderVoucherForm
                    formValues={formValues}
                    setFormValues={setFormValues}
                    content={product}
                    bookingError={bookingError}
                    defaultActiveKey={activeKey}
                    onDefaultActiveKeyChange={setActiveKey}
                    mainContact={isCompanySubAdmin(me) ? me?.firstName : company?.contactName}
                    extraFields={
                        <div>
                            <Collapse
                                ghost={true}
                                accordion={true}
                                className={classNames("marketplace-booking-collapse", {
                                    panelError:
                                        BOOKING_ERROR_TO_PANEL[bookingError] === OrderFormPanelKeys.Payment &&
                                        highlightOrderPanel?.id === OrderFormPanelKeys.Payment
                                })}
                                expandIconPosition="left"
                                activeKey={activeKey}
                                onChange={setActiveKey}
                                expandIcon={({isActive}) => expandIconController(isActive)}>
                                <PaymentPanel
                                    onSyncUserBudget={onSyncUserBudget}
                                    services={services}
                                    me={me}
                                    company={company}
                                    updateCreditCard={setCreditCard}
                                    onPaymentTypeChange={type => setPaymentType(type)}
                                    onInvoiceCommentChange={onInvoiceCommentChange}
                                    invoiceComment={formValues?.invoiceComment}
                                    onInvoicePONumberChange={onInvoicePONumberChange}
                                    invoicePONumber={formValues?.invoicePONumber}
                                    onSeparateInvoiceChange={onSeparateInvoiceChange}
                                    budgetCategoriesPriority={formValues?.budgetCategoriesPriority}
                                    onBudgetCategoriesPriorityChange={onBudgetCategoriesPriorityChange}
                                    separateInvoice={formValues?.separateInvoice}
                                    tenBisCreditCard={formValues?.tenBisCreditCard}
                                    allowedPaymentMethods={
                                        AllowedSystemIdPaymentType[getThemeByOrigin(window.location.origin)]
                                    }
                                    budgetLoadRequestAmount={totalLoadRequestBudgetAmount}
                                    log={log}
                                    shouldSaveCreditCard={false}
                                />
                            </Collapse>
                            <MarketplaceSeparatorLine />
                        </div>
                    }
                />
            ) : (
                <OrderForm
                    adminMode={adminMode}
                    readOnlyFields={readOnlyFields}
                    me={me}
                    company={company}
                    calculateModularProductPrice={calculateModularProductPrice}
                    officeAddress={officeAddress}
                    mainContact={isCompanySubAdmin(me) ? me?.firstName : company?.contactName}
                    content={product}
                    formValues={formValues}
                    setFormValues={setFormValues}
                    updateFormValues={(field, val) => {
                        userFormValues.current = set({...userFormValues?.current}, field, val);
                        setFormValues(prevValues => set({...prevValues}, field, val));
                    }}
                    bookingError={bookingError}
                    providerDetails={providerDetails}
                    defaultActiveKey={activeKey}
                    onDefaultActiveKeyChange={setActiveKey}
                    log={log}
                    extraFields={
                        <div>
                            <Collapse
                                ghost={true}
                                accordion={true}
                                className={classNames("marketplace-booking-collapse", {
                                    panelError:
                                        BOOKING_ERROR_TO_PANEL[bookingError] === OrderFormPanelKeys.Payment &&
                                        highlightOrderPanel?.id === OrderFormPanelKeys.Payment
                                })}
                                expandIconPosition="left"
                                activeKey={activeKey}
                                onChange={setActiveKey}
                                expandIcon={({isActive}) => expandIconController(isActive)}>
                                <PaymentPanel
                                    onSyncUserBudget={onSyncUserBudget}
                                    services={services}
                                    me={me}
                                    company={company}
                                    panelKey={OrderFormPanelKeys.Payment}
                                    updateCreditCard={setCreditCard}
                                    onPaymentTypeChange={type => setPaymentType(type)}
                                    onInvoiceCommentChange={onInvoiceCommentChange}
                                    invoiceComment={formValues?.invoiceComment}
                                    onInvoicePONumberChange={onInvoicePONumberChange}
                                    invoicePONumber={formValues?.invoicePONumber}
                                    onSeparateInvoiceChange={onSeparateInvoiceChange}
                                    budgetCategoriesPriority={formValues?.budgetCategoriesPriority}
                                    onBudgetCategoriesPriorityChange={onBudgetCategoriesPriorityChange}
                                    separateInvoice={formValues?.separateInvoice}
                                    updateFormValues={(field, value) => onFormValueChange(field, value)}
                                    tenBisCreditCard={formValues?.tenBisCreditCard}
                                    allowedPaymentMethods={
                                        AllowedSystemIdPaymentType[getThemeByOrigin(window.location.origin)]
                                    }
                                    budgetLoadRequestAmount={totalLoadRequestBudgetAmount}
                                    log={log}
                                    shouldSaveCreditCard={false}
                                />
                            </Collapse>
                            <MarketplaceSeparatorLine />
                        </div>
                    }
                />
            )}
        </div>
    );
};
